var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7001 8.69961C2.8001 8.69961 1.1001 7.09961 1.1001 5.09961C1.1001 3.09961 2.8001 1.59961 4.7001 1.59961C6.6001 1.59961 8.2001 3.19961 8.2001 5.09961C8.2001 7.09961 6.6001 8.69961 4.7001 8.69961Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 18.2988H3C2 18.2988 1 17.4988 1 16.4988V13.1988C1 12.0988 1.9 11.2988 3 11.2988H6.3C7.3 11.2988 8.2 12.0988 8.2 13.1988V16.4988C8.2 17.3988 7.3 18.2988 6.3 18.2988Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 18.2996H12.6998C11.6998 18.2996 10.7998 17.4996 10.7998 16.3996V3.49961C10.7998 2.49961 11.5998 1.59961 12.6998 1.59961H15.9998C16.9998 1.59961 17.8998 2.39961 17.8998 3.49961V16.3996C17.8998 17.3996 16.9998 18.2996 15.9998 18.2996Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDashboard);
export default __webpack_public_path__ + "static/media/menu_dashboard.45fa1daa38a1c9db4cd663b302300185.svg";
export { ForwardRef as ReactComponent };